export default __webpack_public_path__ + "static/Shcneider-c22f746535a3936f22a3e7389eac6b98.png";